<script>
    import LayoutGrid, {Cell as LayoutCell} from "@smui/layout-grid";
    import DataTable, {Body, Cell, Row} from "@smui/data-table";

    import Currency from "./Currency.svelte";

    export let result = undefined;
    export let span = 4;
    export let cssClass = "no-web";
</script>
<LayoutCell span={span} class="{cssClass}">
    <DataTable style="width: 100%;">
        <Body>
        <Row style="height: 25px;">
            <Cell style="font-weight: bold;">Net à payer avant PAS</Cell>
            <Cell style="text-align: right;font-weight: bold;">
                <Currency number={result.netToPayBeforePAS}/>
            </Cell>
        </Row>
        <Row style="height: 25px;">
            <Cell>PAS</Cell>
            <Cell style="text-align: right">
                <Currency number={result.pasAmount}/>
            </Cell>
        </Row>
        <Row style="height: 25px;font-weight: bold;">
            <Cell style="font-weight: bold;">Net payé</Cell>
            <Cell style="text-align: right;font-weight: bold;">
                <Currency number={result.netToPayAfterPAS}/>
            </Cell>
        </Row>
        </Body>
    </DataTable>
</LayoutCell>